import create from 'zustand'
import { GroundingRenderStep } from './RenderStep'

interface IGroundingAction {
  activeStep: number
  groundingStepInfor: GroundingStep[]
  isBack: boolean
  isSubmit: boolean

  setActiveStep: (code: number) => void
  setGroundingStepInfor: (data: GroundingStep[]) => void
  setIsBack: (back: boolean) => void
  setIsSubmit: (back: boolean) => void
}

export const useGroundingActionStore = create<IGroundingAction>((set, get) => ({
  activeStep: GroundingRenderStep.GRD_ENTER_VIN,
  groundingStepInfor: [],
  isBack: false,
  isSubmit: false,

  setActiveStep: (stepIndex) => {
    const steps = [...get().groundingStepInfor]
    const step = steps.find((s) => s.stepIndex === stepIndex) as GroundingStep
    if (!step) {
      return
    }
    step.active = true
    step.completed = false
    set((state) => ({ ...state, activeStep: step.stepIndex, groundingStepInfor: steps }))
  },
  setGroundingStepInfor: (data) => {
    set((state) => ({ ...state, groundingStepInfor: data }))
  },
  setIsBack: (back) => {
    set((state) => ({ ...state, isBack: back }))
  },
  setIsSubmit: (submit) => {
    set((state) => ({ ...state, isSubmit: submit }))
  }
}))

export interface GroundingStep {
  label: string
  stepIndex: number
  active: boolean
  disabled: boolean
  clicked: boolean
  completed: boolean
  isBack: boolean
  onClick: () => void
}
